import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AdvSearchEvent } from 'src/app/models/adv-search-event-model';
import { MetadataProp } from 'src/app/models/metadata-prop-model';
import { SearchComboItemModel } from 'src/app/models/search-combo-item-model';
import { SuggestRequestModel } from 'src/app/models/suggest-request-model';
import { ConstantsService } from 'src/app/services/constants.service';
import { FormsService } from 'src/app/services/forms.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { PubSearchService } from 'src/app/services/pub-search.service';

@Component({
  selector: 'app-search-property-form',
  templateUrl: './search-property-form.component.html',
  styleUrls: ['./search-property-form.component.css']
})
export class SearchPropertyFormComponent implements OnInit {

  @Input() operatorType: string;
  @Input() mdItems?: MetadataProp[];
  @Input() headerMsg?: string;
  @Input() props!: FormArray;
  @Input() searchForm!: FormGroup

  @Output() addProperty = new EventEmitter<any>();
  @Output() removeProperty = new EventEmitter<any>();
  @Output() clearProperty = new EventEmitter<any>();
  @Output() selectProperty = new EventEmitter<any>();
  @Output() toggleDateProperty = new EventEmitter<any>();

  spaceOperator: string = ' ';
  notOperator: string = '-';
  showCombined = false;
  aSugs: string[] = [];
  aFacetSugs: string[] = [];
  instanceName: string;
  selectedPropertyName: string = '';
  timeIntervals: string[] = [];
  timePlaceholder: string = 'Time';
  dateAddedPropId = '3114a6a1-3ea6-4d08-be5f-859f3c09038e';

  // trackByIndex = (_: number, __:unknown) => _;

  constructor(private fb: FormBuilder, private formSvc: FormsService,
    private mdSvc: MetadataService,
    private searchSvc: PubSearchService,
    public constants: ConstantsService) {
    this.operatorType = this.constants.property_operator_all;
    this.instanceName = '';
  }

  ngOnInit(): void {
    this.instanceName = this.operatorType;
    this.mdItems = this.mdSvc.getSearchable();
    this.timeIntervals = this.formSvc.getTimeIntervals();
  }

  getPropSuggestions(event: any, mdItemId: string, op: string) {
    if (!mdItemId) {
      this.aFacetSugs =[];
      return;
    }

    let mdItem = this.mdItems?.find((m) => m.id == mdItemId) as MetadataProp;
    let propertyName = mdItem.cogSearchKey;

    let suggestQuery: SuggestRequestModel = { q: event.query, propertyName: propertyName, suggester: "sg", operation: op };
    this.searchSvc.getFacetSuggestions(suggestQuery).subscribe((data: string[]) => {
      this.aFacetSugs = data;
    });
  }

  handleKeywordDropDown(event: any) {

  }

  updateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      startTime: prop.startTime,
      endTime: prop.endTime,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: false
    });
  }

  updateDateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      startTime: prop.startTime,
      endTime: prop.endTime,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: true
    });
  }

  addProp() {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType
    }
    this.addProperty.emit(e);
  }

  removeProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.removeProperty.emit(e);
  }

  clearProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.clearProperty.emit(e);
  }

  selectedProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    const item = this.props.at(index).value;
    this.selectedPropertyName = item.propertyItem;

    this.selectProperty.emit(e);
  }

  toggleDateOp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.toggleDateProperty.emit(e);
  }

  propertyKeywordLengthError(control: AbstractControl): boolean {
    return this.formSvc.controlHasKeywordLengthError(control.get('keywords'));
  }
}
